import { compose, setPropTypes } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withReduxStoreFromWindowObject from './withReduxStoreFromWindowObject';
import withAddToBasketHandler from './withAddToBasketAjaxCallHandler';


const withAddToBasketAjaxCallWrapper = compose(
  withReduxStoreFromWindowObject,
  connect((state) => ({
    loadingButtonId:
      state && state.general && state.general.buttonIdTriggeredAddingToBasketInProgress,
    storeTokenIsLoading:
      state && state.general && state.general.storeTokenIsLoading
  })), // Adds dispatch prop automatically from Redux store
  withAddToBasketHandler(),
  setPropTypes(
    {
      thisButtonId: PropTypes.string.isRequired, // ID of this button wrapper
      fupid: PropTypes.string.isRequired,
      quantity: PropTypes.number.isRequired,
      deliverySlotLabel: PropTypes.string, // For MCD Delivery Slot
      deliverySlotPrice: PropTypes.string, // For MCD Delivery Slot
      deliverySlotId: PropTypes.string, // For MCD Delivery Slot
      deliverySlotPostCode: PropTypes.string, // For MCD Delivery Slot
      deliverySlotDate: PropTypes.string, // For REGULAR MCD Delivery Slot
      sameDayDelivery: PropTypes.string, // For Same Day Delivery MCD Delivery Slot
      storeId: PropTypes.number, // For RnC and PnC collections
      deliveryType: PropTypes.oneOf(['RESERVE_AND_COLLECT', 'PAY_AND_COLLECT', 'PAY_AND_COLLECT_FROM_STORE_STOCK']), // For RnC, PnCSS and PnC collections
      visitorId: PropTypes.string, // For Syntasa bundles
      addonProductsIds: PropTypes.arrayOf(PropTypes.string), // accessory products for dynamic bundle,
      addonProductsSegmentIds: PropTypes.arrayOf(PropTypes.number), // accessory products categories for dynamic bundle,
      wasAddedFromWishlist: PropTypes.bool // flag it it was added from wishlist
    }
  )
);

export default withAddToBasketAjaxCallWrapper;
